export const teachers = [
  {
      name: "MANOJ KUMAR SHARMA",
      designation: "Principal",
      department: "Pharmaceutical Quality Assurance",
  },
  {
      name: "YOGENDRA KUMAR KUMAWAT",
      designation: "Assistant Professor",
      department: "Pharmaceutics",
  },
    {
      name: "ASHUTOSH SHARMA",
      designation: "Assistant Professor",
      department: "Pharmacology",
  },
  {
      name: "GOPAL VASHIST",
      designation: "Assistant Professor",
      department: "Pharmacology",
  },
  {
      name: "RAMESH KUMAR",
      designation: "Assistant Professor",
      department: "Community Pharmacy and Management",
  },
  {
      name: "RAMKARAN SAINI",
      designation: "Tutor/ Lecturer",
      department: "Pharmaceutical Chemistry",
  },
    {
      name: "SUBHASH CHAND YADAV",
      designation: "Tutor/ Lecturer",
      department: "Pharmaceutics",
  },
    {
      name: "ARUN KUMAR",
      designation: "Tutor/ Lecturer",
      department: "Social Pharmcy",
  },
];
